/**
 * Carimba o TITULAR em cada ativo da posição consolidada de um grupo familiar.
 *
 * A rota do grupo devolve nos ativos apenas `id_cliente` — não existe `nome_cliente` no payload
 * (medido em 02/09/2026 sobre `/portfolio/consolidation/family-group/<uuid>`: 100+ chaves por
 * ativo, nenhuma com o nome). Quem mostra o membro precisa cruzar esse id com `membros[]`.
 *
 * Fonte ÚNICA. A tela antiga de grupo fazia esse cruzamento inline no seu mixin; a de Carteiras
 * passou a carteira CRUA pro mesmo componente de tabela e a coluna `Membro` saiu `-` em toda
 * linha, com a coluna presente — parecia certa. As duas telas leem daqui agora.
 */
import { resolveNomeDoMembro } from '@modules/consolidator/constants/group-wallet'

/**
 * @param {Object} wallet resposta de consolidação (do grupo)
 * @param {Array} membros `membros[]` do mesmo payload
 * @returns {Object} a mesma carteira com `membro` e `nome_cliente` em cada ativo
 */
export const enrichWalletWithMembers = (wallet, membros = []) => {
  const posicao = wallet && wallet.posicao_completa
  if (!posicao) return wallet
  if (!Array.isArray(posicao.grupos)) {
    return { ...wallet, posicao_completa: { ...posicao, grupos: [] } }
  }
  return {
    ...wallet,
    posicao_completa: {
      ...posicao,
      grupos: posicao.grupos.map((grupo) => ({
        ...grupo,
        ativos: (grupo.ativos || []).map((ativo) => {
          const nome = resolveNomeDoMembro(ativo, membros)
          return {
            ...ativo,
            membro: nome,
            nome_cliente: nome === '-' ? '' : nome,
          }
        }),
      })),
    },
  }
}
